/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://sxwps6i25zbibgxdt74aisjm4u.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-j6ixdmhozva4deuzauscbbsxiq",
    "aws_cognito_identity_pool_id": "us-east-1:d04a1023-7103-49ee-92b8-c831dbdcbee6",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_aUlBHzx0E",
    "aws_user_pools_web_client_id": "50re740mj6r5pvkv4p2u1ho63u",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_mobile_analytics_app_id": "7b3a70afc239488c9d4eb1ff26092491",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
